import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin herramientas para procesar el dolor',
    cost: 'El peso que cargás solo/a cada día'
  }, {
    without: 'Sin guía de escritura emocional',
    cost: 'Las palabras que nunca dijiste siguen en el pecho'
  }, {
    without: 'Sin ritual de 7 días',
    cost: 'Sin estructura en los momentos más difíciles'
  }, {
    without: 'Sin frases de contención',
    cost: 'Quedás expuesta/o ante el dolor sin nada que te sostenga'
  }, {
    without: 'Sin guía para fechas difíciles',
    cost: 'Cumpleaños, Día de la Madre y Navidad sin preparación'
  }, {
    without: 'Sin protocolo para la culpa',
    cost: 'Seguís creyendo que avanzar es traicionarla'
  }, {
    without: 'Sin guía de legado y continuidad',
    cost: 'Tu vida congelada por el miedo a olvidarla'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo dolor sin dirección, la próxima semana'
  }];
  return <Section data-id="element-16">
      <div className="text-center mb-12" data-id="element-17">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-pinkDark" data-id="element-18">
          <span className="mr-3" data-id="element-19">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-20">
        <div className="hidden md:block" data-id="element-21">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-22">
            <div className="font-serif font-bold text-lg text-brand-pink" data-id="element-23">
              Sin Santuario Digital
            </div>
            <div className="font-serif font-bold text-lg text-brand-dark" data-id="element-24">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-25">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-dark/10 bg-white/70" data-id="element-26">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-27">
                  {row.without}
                </div>
                <div className="text-sm text-brand-dark/90 font-medium" data-id="element-28">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-29">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-dark/10 bg-white/70 space-y-2" data-id="element-30">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-31">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-dark/90 font-medium" data-id="element-32">
                <span className="text-brand-dark shrink-0" data-id="element-33">→</span>
                <span className="text-sm" data-id="element-34">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-35">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-pinkDark" data-id="element-36">
          "La persona que tiene herramientas para atravesar el duelo, sana con
          más paz. La que sana con paz, vuelve a vivir con amor. La que vive con
          amor, honra a su madre de la manera más profunda." 🌿
        </p>
      </div>
    </Section>;
};